import React from "react";
import {
  PageSuspense,
  TrpsPaymentInfo,
  ClientsPaymentInfo,
  PaymentPage,
  AlertConfiguration,
  CaseGroupDetail,
  ClientGroupDetail,
  Groups,
  EditClientSelf,
  UpdatePermissions,
} from "../lazyComponents";
import type { AppRoute } from "../types";

export const paymentsGroupsAdminRoutes: AppRoute[] = [
  {
    path: "/TrpsPaymentInfo",
    main: () => (
      <PageSuspense>
        <TrpsPaymentInfo />
      </PageSuspense>
    ),
  },
  {
    path: "/ClientsPaymentInfo",
    main: () => (
      <PageSuspense>
        <ClientsPaymentInfo />
      </PageSuspense>
    ),
  },
  {
    path: "/PaymentPage",
    main: () => (
      <PageSuspense>
        <PaymentPage />
      </PageSuspense>
    ),
  },
  {
    path: "/AlertConfiguration",
    main: () => (
      <PageSuspense>
        <AlertConfiguration />
      </PageSuspense>
    ),
  },
  {
    path: "/groups/case-group/:caseGroupId",
    main: () => (
      <PageSuspense>
        <CaseGroupDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/groups/client-group/:clientGroupId",
    main: () => (
      <PageSuspense>
        <ClientGroupDetail />
      </PageSuspense>
    ),
  },
  {
    path: "/groups",
    main: () => (
      <PageSuspense>
        <Groups />
      </PageSuspense>
    ),
  },
  {
    path: "/EditClientSelf",
    main: () => (
      <PageSuspense>
        <EditClientSelf />
      </PageSuspense>
    ),
  },
  {
    path: "/UpdatePermissions",
    main: () => (
      <PageSuspense>
        <UpdatePermissions />
      </PageSuspense>
    ),
  },
];
